export default __webpack_public_path__ + "static/media/item_11_active.4ac09914.png";